<template>
  <div>
    <v-card v-if="this.$vuetify.breakpoint.name === 'xs'" class="py-12 px-4 text-center rounded-xl" style="background: rgba(255, 255, 255, 0.9)" >
      <v-card-title class="mt-n13">
        <v-img contain height="127" width="137" :src="require('@/assets/infohidro-logo.svg')"></v-img>
      </v-card-title>
      <v-card-text class="black--text text--lighten-1 mb-n16">
        <span class="font-weight-regular">Dados de qualidade para a gestão de segurança hídrica.</span>
        <v-row class="mt-0" justify="center">
          <v-col cols="6">
            <img class="mr-md-3 mt-md-0 mb-3 mb-sm-6 mb-md-0"  width="80" height="24" :src="require('@/assets/simepar-logo-preto.svg')"/>
          </v-col>
          <v-col cols="6">
            <img class="ml-md-3"  width="80" height="24" :src="require('@/assets/grey-sanepar.svg')"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-else class="py-12 px-4 text-center rounded-xl" style="background: rgba(255, 255, 255, 0.9)" >
      <v-card-title class="mt-4 pa-2">
        <v-img contain height="218" width="228" :src="require('@/assets/infohidro-logo.svg')"></v-img>
      </v-card-title>
      <v-card-text class="mb-4 black--text text--lighten-1">
        <span class="font-weight-regular">Dados de qualidade para a gestão de segurança hídrica.</span>
        <v-row class="mt-5" justify="center" >
          <v-col>
            <img class="mr-md-3 mt-md-0 mb-6 mb-sm-6 mb-md-0"  width="140" height="42" :src="require('@/assets/simepar-logo-preto.svg')"/>
          </v-col>
          <v-col>
            <img class="ml-md-3"  width="140" height="42" :src="require('@/assets/grey-sanepar.svg')"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    name:'logo'
}
</script>

<style scoped>

</style>
